import { enviroment } from "../../enviroment";

/**
 * True when the current browser hostname is one of the configured
 * old-webshop-migration hosts (REACT_APP_MIGRATION_HOSTS, e.g.
 * "webshop2.jetsport.dk"). Those hosts serve the migration lookalike page as
 * their front page (see index.tsx). An empty/unset list always returns false,
 * so every normal host (kitmaker dev/prod and the whitelabel domains) keeps
 * byte-identical routing.
 */
export function isMigrationHost(): boolean {
  return enviroment.migrationHosts.includes(
    window.location.hostname.toLowerCase(),
  );
}
